<!-- <template>
  <div class="reviewHistory">
    <slot-table :data="tableData" :columns="table.columns">
      <template slot="createdBy" slot-scope="props">
          <span>
           <a v-bind:href="
           `mailto:${props.item.creator.email}?subject=Otomo Review Link - ${props.item.name}`" target="_blank">{{ props.item.creator.name }}</a>
          </span>
      </template>

      <template slot="name" slot-scope="props">
            <span v-if="props.item.deleted" v-bind:href="reviewLinkUrl(props.item)" target="_blank">
              {{ props.item.name }}
            </span>
            <a v-else v-bind:href="reviewLinkUrl(props.item)" target="_blank">
              {{ props.item.name }}
            </a>
      </template>
      <template slot="dateCreated" slot-scope="props">
          <span>
            {{ props.item.date_created.value }}
          </span>
      </template>
      <template slot="status" slot-scope="props">
          <span :class="statusCss(props.item)">
            {{ statusText(props.item) }}
          </span>
      </template>
      <template slot="actions" slot-scope="props">
            <button class="btn btn-xs btn-primary ml-4">
              <i  class="fa fa-times"></i>
              <i  class="fa fa-info"></i>
            </button>
      </template>
    </slot-table>
  </div>
</template> -->
<!-- £££££££££££££££££££££££££££££££££££££££££££££££££££££££££££££££££££££££££££££££££££? -->
<template>
  <div class="reviewHistory">
    <table class="table table-striped table-hover">
      <thead class="fixedHeader">
      <tr>
        <th>
          Created By
        </th>
        <th>
          Name
        </th>
        <th>
          Date Created
        </th>
        <th>
          Status
        </th>
        <th>
          Actions
        </th>
      </tr>
      </thead>
      <tbody class="scrollContent" v-for="item in tableData" :key="item.id">
      <tr>
          <td>
            <span>
              <a
                :href="`mailto:${item.creator.email}?subject=Otomo Review Link - ${item.name}`"
                target="_blank"
              >{{ item.creator.name }}</a>
            </span>
          </td>
          <td>
            <a :href="reviewLinkUrl(item)" target="_blank">{{ item.name }}</a>
          </td>
          <td>{{ item.date_created.value }}</td>
          <td>
           <span :class="statusCss(item)">
            {{ statusText(item).replace('_', ' ') }}
          </span>
          </td>
          <td>
            <button class="btn btn-xs btn-primary ml-4" @click="toggleAccordion(item.hash_id)">
              <i v-if="isAccordionOpen(item.hash_id)" class="fa fa-times"></i>
              <i v-else class="fa fa-info"></i>
            </button>
          </td>
      </tr>
       <tr v-if="isAccordionOpen(item.hash_id)">
          <td colspan="5">
            <accordion>
            <ul>
              <li v-for="(entry, index) in item.entries" :key="index">
               {{ entry.name }}
              </li>
            </ul>
          </accordion>
          </td>
       </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import SlotTable from '@/components/Table/table'
import Heading from '@/components/Heading/heading'
import {downloadMixin} from '@/mixins/downloadMixin'

import { MEDIA_URL } from '@/config'
import {authMixin} from '@/mixins/authMixin'

export default {
  name: 'review-link-history-table',
  mixins: [downloadMixin, authMixin],
  components: {
    SlotTable,
    Heading
  },
  props: {
    tableData: Array
  },
  data: () => ({
    table: {
      columns: {
        createdBy: 'Created By',
        name: 'Name',
        dateCreated: 'Date Created',
        status: 'Status',
        actions: 'Actions'
      },
      statusKeys: {
        success: 'success',
        error: 'danger',
        in_progress: 'info',
        created: 'warning'
      }
    },
    openAccordions: []
  }),
  methods: {
    statusText (item) {
      if (item.deleted) return 'deleted'
      if (item.status !== 'completed') return 'processing build'
      if (item.status === 'completed') {
        return item.feedback_submitted ? 'feedback submitted' : 'pending'
      }
      return item.status
    },
    statusCss (item) {
      console.log('datatable', this.tableData)
      let labelType = 'default'
      if (item.status === 'error') labelType = this.table.statusKeys.error
      if (item.status !== 'completed') labelType = this.table.statusKeys.created
      if (item.status === 'completed') {
        labelType = item.feedback_submitted ? this.table.statusKeys.success : this.table.statusKeys.in_progress
      }
      if (item.deleted) labelType = this.table.statusKeys.error
      return `label label-${labelType} text-center text-capitalize`
    },
    reviewLinkUrl (item) {
      const path = `/api_v2/review/feedback/${item.hash_id}?token=${btoa(unescape(encodeURIComponent(this.getAccessToken)))}`
      let MEDIA_URL_UPDATE = MEDIA_URL.replace('store/', '')
      return MEDIA_URL_UPDATE + path.substring(1)
    },
    toggleAccordion (hashId) {
      if (this.isAccordionOpen(hashId)) {
        const index = this.openAccordions.indexOf(hashId)
        if (index !== -1) {
          this.openAccordions.splice(index, 1)
        }
      } else {
        this.openAccordions && this.openAccordions.push(hashId)
      }
    },
    isAccordionOpen (hashId) {
      return this.openAccordions && this.openAccordions.includes(hashId)
    }
  }
}
</script>

<style lang="scss">
.asset__img, .asset__video {
  background-color: #ccc;
  background-image: linear-gradient(45deg, rgba(0, 0, 0, .2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, .2) 75%, rgba(0, 0, 0, .2)), linear-gradient(45deg, rgba(0, 0, 0, .2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, .2) 75%, rgba(0, 0, 0, .2));
  background-size: 10px 10px;
  background-position: 0 0, 5px 5px;
  padding: 0px;
  max-width: 200px;
  max-height: 200px;
  img, video {
    object-fit: scale-down;
    border:2px solid #2c3247;
  }
  & #imageCover {
    z-index:50;
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(123,123,123,0);
  }
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.asset__video {
  background-color: black;
  max-width: 320px;
  max-height: 320px;
}
.top-buffer {
  margin-top:10px;
}

.progress-percentage {
  display: flex;
  align-content: center;
}

.loader-hidden {
  display: inline-block;
  width: 15px;
  height: 15px;
}

.loader {
  display: inline-block;
  width: 15px;
  height: 15px;
  margin-right: 2px;
  background-color: #333;

  border-radius: 100%;
  -webkit-animation: sk-scaleout 1.0s infinite ease-in-out;
  animation: sk-scaleout 1.0s infinite ease-in-out;
}

@-webkit-keyframes sk-scaleout {
  0% { -webkit-transform: scale(0) }
  100% {
    -webkit-transform: scale(1.0);
    opacity: 0;
  }
}

@keyframes sk-scaleout {
  0% {
    -webkit-transform: scale(0);
    transform: scale(0);
  } 100% {
      -webkit-transform: scale(1.0);
      transform: scale(1.0);
      opacity: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Modal/links/components/review-link-history-table.vue